export const CUSTOM_DOMAIN = {
  DPD_UK_DEV: "dpduk.dev",
  DPD_CO_UK: "dpd.co.uk",
  DPD_LOCAL_CO_UK: "dpdlocal.co.uk"
};
export const BUSINESS_UNIT = {
  DPD: 1,
  DPD_LOCAL: 2
};